export const opsPromptLibrary: string[] = [
  'Show instructed settlements and open Instruct Settlement.',
  'Generate a SWIFT MT103 payment from an instructed settlement.',
  'Run netting for eligible USD settlements.',
  'Show netting sets for today in USD.',
  'Open journal list for the current month.',
  'Post a settlement entry for a specific deal.',
  'Show closeout batches for today.',
  'Open matched book in USD.',
  'Create an execution instruction for a repo unwind.',
];
